export default __webpack_public_path__ + "static/media/505.8d1f8fdd.gif";